 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import INTRODUCTION from '@/components/introduction'
 import THEDRAGONSCAT from '@/components/the-dragons-cat'
 import SOBURNUSBOTH from '@/components/so-burn-us-both'
 import TRIALBYCOW from '@/components/trial-by-cow'
 import BLACKWOODSTOMB from '@/components/blackwoods-tomb'
 import THERITUALISTANDTHEHEDGEWIZARD from '@/components/the-ritualist-and-the-hedge-wizard'
 import BENEATHTHEWINGSOFNIGHT from '@/components/beneath-the-wings-of-night'
 import KITTENFORSALE from '@/components/kitten-for-sale'
 import THEDREAMER from '@/components/the-dreamer'
 import ARATAROOTANDABIGORANGEFRUIT from '@/components/a-rat-a-root-and-a-big-orange-fruit'
 import SECONDLIFE from '@/components/second-life'
 import THEWITCHINGHOURLETTERS from '@/components/the-witching-hour-letters'
 import THEFAMILIARSFAMILIAR from '@/components/the-familiars-familiar'
 import THECAT from '@/components/the-cat'
 import SOMESPIDER from '@/components/some-spider'
 import SCARYSCARYSKUNK from '@/components/scary-scary-skunk'
 import ORPHANS from '@/components/orphans'
 import THELASTLIFEOFHILDETHESMALL from '@/components/the-last-life-of-hilde-the-small'
 import ANDHAVENEVERFORGOTTEN from '@/components/and-have-never-forgotten'
 import FLUFFY from '@/components/fluffy'
 import EARTHBONDING from '@/components/earth-bonding'
 import NOTCOMMONAFIBONACCIPOEM from '@/components/not-common-a-fibonacci-poem'
 import THESECRETOFTHESORCERESS from '@/components/the-secret-of-the-sorceress'
 import SINKORSWIM from '@/components/sink-or-swim'
 import OLDCROW from '@/components/old-crow'
 import TAILEND from '@/components/tail-end'
 import NAMELESS from '@/components/nameless'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import ABOUTTHEEXECUTIVEEDITORS from '@/components/about-the-executive-editors'
 import IFYOUENJOYEDFEISTYFELINES from '@/components/if-you-enjoyed-feisty-felines'
 import COPYRIGHTINFORMATION from '@/components/copyright-information'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/the-dragons-cat",
 			"name" : "the-dragons-cat",
 			"component" : THEDRAGONSCAT
 		},
 		{
 			"path" : "/so-burn-us-both",
 			"name" : "so-burn-us-both",
 			"component" : SOBURNUSBOTH
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js